/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */

import { is } from 'ramda'

import { useRedirection } from '../redirection.js'

import { replaceWithResolvedRoute } from '../utils/replace-with-resolved-route.js'
import { removeLeadingSlash } from '../utils/remove-leading-slash.js'

export const targetUrlRedirect = ({ route, onboardingFinished, store, router, logger, defaultRedirect, useChat }) => {
  let r

  // original redirection url
  if (is(Object, route.params.redirection)) {
    r = route.params.redirection
    delete route.params.redirection
  }

  // open help chat from deeplink
  // TODO move out of the default redirect
  if (r?.query?.support) {
    if (r.query.support === 'true') {
      const chat = useChat()
      chat.open()
    }
    delete r.query.support
  }

  if (r && (r.name || removeLeadingSlash(r.path))) {
    r.params = r.params || {}

    if (!r.params.businessId) {
      r.params.businessId = store.getters['business/businessId']
    }

    if (removeLeadingSlash(r.path) && !r.name) {
      r = router.resolve(r, {})
    }

    // shortcut: redirect to original url
    return replaceWithResolvedRoute(router, r).then(route => {
      useRedirection().clear()
      if (!route?.matched?.length || !route.name) {
        logger.error('redirection failed!', r)
        return defaultRedirect({ onboardingFinished })
      }
      logger.debug(`target url found! >>> ${route.name}`)
      return route
    })
  }
}
